// stages of the activity
export const ACTIVITY_PLANNING = "Planning";
export const ACTIVITY_PREPARATION = "Preparation";
export const ACTIVITY_EXECUTION = "Execution";
export const ACTIVITY_REPORTING = "Reporting";
export const ACTIVITY_SURVEILLANCE_FINDING = "Surveillance Finding";
export const ACTIVITY_CLOSED = "Closed";
